<div class="page-container dashboard-container container">
  <!-- leaving the following for any announcements that dashboard team wants to display.
  @if (!rights.includes('SE')) {
    <div class="advertisement-banner">
      Announcing the new Rep Behavior Page!
      <button (click)="nav('/rep-behavior')">Click here to learn more</button>
    </div>
  } -->

  <div class="row w-100">
    <app-utility-toolbar
      class="{{ navCollapsed ? 'w-5' : 'w-15' }} vertical"
      [current]="app"
      [vertical]="true"
      [links]="dashboardLinks"
      (toggleCollapse)="toggleNavCollapse()"
    />

    @if (!rights.includes('SE')) {
      <div
        class="content-container ps-2"
        [ngClass]="{ collapsed: navCollapsed }"
      >
        <div class="custom-tabs">
          <div>
            <mat-tab-group #tabGroup class="w-100 mb-3">
              <mat-tab label="System Usage">
                <ng-template matTabContent>
                  <app-system-usage-tab class="w-100" />
                </ng-template>
              </mat-tab>

              <mat-tab label="Category & Product">
                <ng-template matTabContent>
                  <app-recommended-products-tab class="w-100" />
                </ng-template>
              </mat-tab>

              <mat-tab label="Score Class">
                <ng-template matTabContent class="w-100">
                  <app-scoreclass-tab />
                </ng-template>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </div>
    } @else {
      <div class="content-container {{ navCollapsed ? 'w-95' : 'w-85' }} pl-2">
        <app-se-dashboard />
      </div>
    }
  </div>
</div>
